import { render, staticRenderFns } from "./ProductPriceViewer.vue?vue&type=template&id=5bfeca21&"
import script from "./ProductPriceViewer.vue?vue&type=script&lang=js&"
export * from "./ProductPriceViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports